import axios from 'axios';
import { apiDomain } from '@/config';

import * as types from './types';

const actions = {
  reset: ({ commit }) => {
    commit(types.RESET);
  },
  async fetchEmployeeProfile({ commit }) {
    commit(types.FETCH_EMPLOYEE_PROFILE_PENDING);
    try {
      const response = await axios.get(`${apiDomain}employee`);
      commit(types.FETCH_EMPLOYEE_PROFILE_FULFILLED, response.data);
      return true;
    } catch (error) {
      commit(types.FETCH_EMPLOYEE_PROFILE_ERROR);
      return Promise.reject(error);
    }
  },
  async updateEmployeeProfile({ commit }, form) {
    commit(types.UPDATE_EMPLOYEE_PROFILE_PENDING);
    try {
      const response = await axios.post(`${apiDomain}employee`, form);
      commit(types.UPDATE_EMPLOYEE_PROFILE_FULFILLED, response);
      return true;
    } catch (error) {
      commit(types.UPDATE_EMPLOYEE_PROFILE_ERROR);
      return Promise.reject(error);
    }
  },
  async fetchResume({ commit }) {
    commit(types.FETCH_RESUME_PENDING);
    try {
      const response = await axios.get(`${apiDomain}employee/resume`);
      commit(types.FETCH_RESUME_FULFILLED, response);
      return true;
    } catch (error) {
      commit(types.FETCH_RESUME_ERROR);
      return Promise.reject(error);
    }
  },
  async fetchResumeItem({ commit }, { type, id }) {
    commit(types.FETCH_RESUME_ITEM_PENDING);
    try {
      const response = await axios.get(`${apiDomain}employee/resume/${type}/${id}`);
      commit(types.FETCH_RESUME_ITEM_FULFILLED, response.data.data);
      return response;
    } catch (error) {
      commit(types.FETCH_RESUME_ITEM_ERROR);
      return Promise.reject(error);
    }
  },
  async storeResumeItem({ commit, dispatch }, payload) {
    commit(types.STORE_RESUME_ITEM_PENDING);
    try {
      const method = payload.item.id ? 'PUT' : 'POST';
      const url = payload.item.id
        ? `${apiDomain}employee/resume/${payload.type}/${payload.item.id}`
        : `${apiDomain}employee/resume/${payload.type}`;
      await axios({ url, method, data: payload.item });
      await dispatch('fetchResume');
      commit(types.STORE_RESUME_ITEM_FULFILLED);
      dispatch('messages/showMessage', { key: payload.successMessageKey, color: 'success' }, { root: true });
      return true;
    } catch (error) {
      commit(types.STORE_RESUME_ITEM_ERROR);
      dispatch('messages/showMessage', { key: payload.errorMessageKey, color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
  async deleteResumeItem({ commit, dispatch }, payload) {
    commit(types.DELETE_RESUME_ITEM_PENDING);
    try {
      await axios.delete(`${apiDomain}employee/resume/${payload.type}/${payload.item.id}`);
      await dispatch('fetchResume');
      commit(types.DELETE_RESUME_ITEM_FULFILLED);
      const successMessage = payload.successMessageKey || 'alert.deleteResumeOtherDocumentsSuccessful';
      dispatch('messages/showMessage', { key: successMessage, color: 'success' }, { root: true });
      return true;
    } catch (error) {
      commit(types.DELETE_RESUME_ITEM_ERROR);
      const errorMessage = payload.errorMessageKey || 'alert.deleteResumeOtherDocumentsError';
      dispatch('messages/showMessage', { key: errorMessage, color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
  async fetchApplications({ commit }, payload) {
    commit(types.FETCH_APPLICATIONS_PENDING);
    try {
      const listType = payload && payload.listType ? payload.listType : 'all';
      const baseUrl = `${apiDomain}employee/applications`;
      const url = listType !== 'all' ? `${baseUrl}?scope=${listType}` : baseUrl;
      const response = await axios.get(url);
      commit(types.FETCH_APPLICATIONS_FULFILLED, { data: response.data, listType });
      return true;
    } catch (error) {
      commit(types.FETCH_APPLICATIONS_ERROR);
      return Promise.reject(error);
    }
  },
  async storeApplication({ commit, dispatch }, application) {
    commit(types.STORE_APPLICATION_PENDING);
    try {
      const method = application.id ? 'PUT' : 'POST';
      const baseUrl = `${apiDomain}employee/applications`;
      const url = application.id ? `${baseUrl}/${application.id}` : baseUrl;
      const response = await axios({ url, method, data: application });
      await dispatch('fetchApplications');
      commit(types.STORE_APPLICATION_FULFILLED);
      dispatch('messages/showMessage', { key: 'alert.addJobApplicationSuccessful', color: 'success' }, { root: true });
      return Promise.resolve(response.data.data);
    } catch (error) {
      commit(types.STORE_APPLICATION_ERROR);
      dispatch('messages/showMessage', { key: 'alert.addJobApplicationError', color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
  saveApplicationInEdit({ commit }, payload) {
    commit(types.SAVE_APPLICATION_IN_EDIT, payload);
  },
  async deleteJobApplication({ commit, dispatch }, payload) {
    commit(types.DELETE_JOB_APPLICATION_PENDING);
    try {
      const response = await axios.delete(`${apiDomain}employee/applications/${payload.id}`);
      await dispatch('fetchApplications');
      commit(types.DELETE_JOB_APPLICATION_FULFILLED, response);
      dispatch('messages/showMessage', { key: 'alert.deleteJobApplicationSuccessful', color: 'success' }, { root: true });
      return true;
    } catch (error) {
      commit(types.DELETE_JOB_APPLICATION_ERROR);
      dispatch('messages/showMessage', { key: 'alert.deleteJobApplicationError', color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
  async fetchCooperationAgreements({ commit }) {
    commit(types.FETCH_COOPERATION_AGREEMENTS_PENDING);
    try {
      const response = await axios.get(`${apiDomain}employee/cooperation_agreements`);
      commit(types.FETCH_COOPERATION_AGREEMENTS_FULFILLED, response);
      return true;
    } catch (error) {
      commit(types.FETCH_COOPERATION_AGREEMENTS_ERROR);
      return Promise.reject(error);
    }
  },
};

export default actions;
